import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, Label } from 'reactstrap';

const FormReadonlyEdit = ({ label, value, onClick }) => {
  return (
    <FormGroup className="form-readonly">
      <Label className="form-label">{label}</Label>
      <div className="mt-2">
        {value}&nbsp;
        <i
          id="editEngineeringTeamLead"
          className="fa fa-edit text-primary"
          onClick={() => {
            onClick(true);
          }}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </FormGroup>
  );
};

FormReadonlyEdit.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
};

export { FormReadonlyEdit };
